import { NgModule } from '@angular/core';
import { CommonDateRangeModule } from '@widgets/site-common/common-date-range/common-date-range.module';
import { CommonInlineListModule } from '@widgets/site-common/common-inline-list/common-inline-list.module';
import { CommonPillSliderModule } from '@widgets/site-common/common-pill-slider/common-pill-slider.module';
import { CommonSearchBarModule } from '@widgets/site-common/common-search-bar/common-search-bar.module';
import { CommonSingleDropdownModule } from '@widgets/site-common/common-single-dropdown/common-single-dropdown.module';
import { CommonTableModule } from '@widgets/site-common/common-table/common-table.module';
import { FilePreviewModule } from '@widgets/site-common/file-preview/file-preview.module';
import { FillSiteInputModule } from '@widgets/site-common/fill-site-input/fill-site-input.module';
import { LinkPreviewModule } from '@widgets/site-common/link-preview/link-preview.module';
import { NavbarModule } from '@widgets/site-common/navbar/navbar.module';
import { PageHeaderModule } from '@widgets/site-common/page-header/page-header.module';
import { PanelsModule } from '@widgets/site-common/panels/panels.module';
import { QPCompanySelectModule } from '@widgets/site-common/qp-company-select/qp-company-select.module';
import { QpSelectModule } from '@widgets/site-common/qp-select/qp-select.module';
import { SourceSiteHistoryInputModule } from '@widgets/site-common/source-site-history-input/source-site-history-input.module';
import { SourceTypeInputModule } from '@widgets/site-common/source-type-input/source-type-input.module';
import { StatusOverviewModule } from '@widgets/site-common/status-overview/status-overview.module';
import { UserAssignmentModule } from '@widgets/site-common/user-assignment/user-assignment.module';
import { UiCommonModule } from '@widgets/ui-common/ui.common.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { CommonStatusDropdownModule } from './common-status-dropdown/common-status-dropdown.module';
import { ConfirmDialogModule } from './confirm-dialog/confirm-dialog.module';
import { FavoriteCheckboxModule } from './favorite-checkbox/favorite-checkbox.module';
import { FileUploadListModule } from './file-upload-list/file-upload-list.module';
import { FileUploadModule } from './file-upload/file-upload.module';
import { FillSiteSelectComponent } from './fill-site-select/fill-site-select.component';
import { GeoCodeAddressAutocompleteModule } from './geo-code-address-autocomplete/geo-code-address-autocomplete.module';
import { SearchFilterModule } from './search-filter/search-filter.module';
import { SiteAssignmentModule } from './site-assignment/site-assignment.module';
import { SnackbarModule } from './snackbar/snackbar.module';

const SITE_COMMON_MODULES = [
  UiCommonModule,
  FilePreviewModule,
  FileUploadModule,
  FileUploadListModule,
  FillSiteInputModule,
  LinkPreviewModule,
  NavbarModule,
  PageHeaderModule,
  PanelsModule,
  SearchFilterModule,
  SnackbarModule,
  SourceSiteHistoryInputModule,
  SourceTypeInputModule,
  StatusOverviewModule,
  CommonTableModule,
  CommonStatusDropdownModule,
  CommonTableModule,
  CommonSearchBarModule,
  CommonDateRangeModule,
  FavoriteCheckboxModule,
  QpSelectModule,
  QPCompanySelectModule,
  ConfirmDialogModule,
  CommonPillSliderModule,
  CommonSingleDropdownModule,
  CommonInlineListModule,
  GeoCodeAddressAutocompleteModule,
  UserAssignmentModule,
  SiteAssignmentModule
];

@NgModule({
  declarations: [FillSiteSelectComponent],
  imports: [...SITE_COMMON_MODULES, NgxPermissionsModule.forChild()],
  exports: [...SITE_COMMON_MODULES, NgxPermissionsModule]
})
export class SiteCommonModule {}
